import { useQuery } from '@tanstack/react-query';
import { getOverdueInvoices } from '../../service';

export function useOverdueInvoices({
    propertyManagerId = undefined,
    uploadingRefetechInterval = false,
}: {
    propertyManagerId?: string;
    uploadingRefetechInterval?: false | number;
} = {}) {
    const query = useQuery({
        queryKey: ['dashboard', 'tab', 'overdue-invoices', { propertyManagerId }],
        queryFn: () => getOverdueInvoices({
            propertyManagerId,
        }),
        refetchInterval: (overdueInvoiceQuery) => {
            if (uploadingRefetechInterval === false) {
                return false;
            }

            if (overdueInvoiceQuery.state.data?.items === undefined) {
                return false;
            }

            // We want to continually refetch while
            // there are invoices that are still uploading
            return overdueInvoiceQuery.state.data.items
                .some((invoice) => invoice.integration.isUploading)
                ? uploadingRefetechInterval
                : false;
        },
    });

    return query;
}
